/**
 * Sidebar Modal - What Makes POSSIBLE Different?
 */

class SidebarModal {
  constructor(modalId) {
    this.modal = document.getElementById(modalId);
    if (!this.modal) return;

    this.trigger = document.querySelector('.what-makes-different-cta-button');
    this.closeButton = this.modal.querySelector('.sidebar-modal-close');
    this.overlay = this.modal;

    this.init();
  }

  init() {
    // Open modal on CTA click
    if (this.trigger) {
      this.trigger.addEventListener('click', () => this.open());
    }

    // Close modal on X button click
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.close());
    }

    // Close modal on overlay click (but not on sidebar click)
    this.overlay.addEventListener('click', (e) => {
      if (e.target === this.overlay) {
        this.close();
      }
    });

    // Close modal on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.modal.classList.contains('active')) {
        this.close();
      }
    });
  }

  open() {
    this.modal.classList.add('active');
    document.body.style.overflow = 'hidden'; // Prevent background scroll
  }

  close() {
    this.modal.classList.remove('active');
    document.body.style.overflow = ''; // Restore scroll
  }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
  new SidebarModal('whatMakesDifferentModal');
});
